import { Injectable, Inject } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { YouTubeService } from './youtube.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/observable/of';
// import * as _ from 'lodash';
import * as firebase from 'firebase';

@Injectable({
  providedIn: 'root',
})
export class UsersService {

  HAS_LOGGED_IN = 'hasLoggedIn';
  public fbDB: any;
  public fbStorage: any;
  public userData: any;
  public dbVideosListRef: any;
  public dbUsersListRef: any;
  public googleMapsAPIKey = 'AIzaSyDDz-MjBSirogMTm-BiJZQdint7OYMY-20';

  constructor(
    private db:AngularFireDatabase,
    private _yt: YouTubeService,
    public http: HttpClient,
    //private _geo: Geolocation
  ) {
    this.dbVideosListRef = firebase.database().ref('/social/videos');
    this.dbUsersListRef = firebase.database().ref('/social/users');

    // // Setup the db references
    this.fbDB = firebase.database();
    this.fbStorage = firebase.storage();

  }

  /**
   *  Get current user profile image
   */
  getCurrentUserProfileImage(uid) {
    return this.db.object(`/social/users/${uid}/profile_photo`);
  }


  /**
    * Pull the user out of local storage
    * and update the user's coordinates
    */
  // updateGeolocationCoords() {

  //   this.storage.get('user').then(data => {

  //     // Get geolocation
  //     this._geo.getCurrentPosition().then((resp) => {

  //       let user = {
  //         _geoloc: {
  //           lat: resp.coords.latitude,
  //           lng: resp.coords.longitude,
  //         }
  //       }

  //       // Get timezone, based on location
  //       let timezoneUrl = `https://maps.googleapis.com/maps/api/timezone/json?location=${user._geoloc.lat},${user._geoloc.lng}&timestamp=${new Date().getTime()/1000}&key=${this.googleMapsAPIKey}`;
  //       this.http.get(timezoneUrl)
  //         .map(res => res.json())
  //         .subscribe(timezone => {

  //           user['_geoloc']['timezone'] = timezone.timeZoneId;
  //           data['timezone'] = timezone.timeZoneId;

  //           // Update timezone in local storage
  //           this.storage.set('user', data);

  //           // Update timezone in db
  //           this.db.object(`/social/users/${data.id}`).update(user);
  //       });


  //     }).catch((error) => {});

  //   })
  // }


  /**
   *  Update the online status of the current user
   */
  updateOnlineStatus(userId, isConnected) {
    this.db.object(`/social/users/${userId}`).update({
      is_connected: isConnected
    });
  }


  /**
   *  Check if a user is logged in
   */
  hasLoggedIn() {
    // return this.storage.get('user').then((value) => {
    //   if(value !== undefined && value !== null) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // });
  }

  /**
   *  Simple "Get User"
   */
  getUser(id) {
    return this.db.object(`/social/users/${id}`)
  }

  /**
   *  Get user profile
   */
  getUserProfile(id) {

    return this.db.object(`/social/users/${id}`)

      // Switch to the joined observable

      .switchMap((user) => {

        if(user.videos && (Object.keys(user.videos).length > 0)) {
        let vidKeys = Object.keys(user.videos);

          // Use forkJoin to join the video observables. The observables will
          // need to complete, so first is used. And use forkJoin's selector to
          // map the videos to the user and then return the user.

          return Observable.combineLatest(
            vidKeys.map((vidKey) => this.db
              .object(`/social/videos/${vidKey}`)
            ),
            (...videos) => {
              vidKeys.forEach((vidKey, index) => {

                // Query YouTube api to get the duration
                this._yt.getVideo(vidKey).subscribe(data => {

                  // Format the duration
                  let duration = this._yt.convertToStandardDuration(data.items[0].contentDetails.duration)
                  videos[index]['duration'] = duration;
                  user.videos[vidKey] = videos[index];

                });

               });
              return user;
            }
          )
        } else {
          return Observable.of(user);
        }
      });
  }


  /*
   *  Get user settings
   */
  getMusicianProfileSettings(id) {
    return this.db.object(`/social/users/${id}`);
  }



  /**
   *  Function to get the user's connections
   */
  getUserConnections(data) {

    return this.db
      .object(`/social/user_connections/${data.id}`)

      // Switch to the joined observable

      .switchMap((connections) => {
        console.log('connections inner?', connections);
        // Does the user have connections?
        if(connections.$value !== null) {

          let connectionKeys = Object.keys(connections);
          return Observable.combineLatest(
            connectionKeys.map((connectionKey) => {
              return this.db
              .object(`/social/users/${connectionKey}`)}
            ),
            (...connectionUsers) => {
              return connectionUsers;
            }
          );
        } else {
          return Observable.of([]);
        }
      });
  }


  /**
   *  Get user connections for a user
   */
  getPureUserConnections(userId) {
    return this.db
      .object(`/social/user_connections/${userId}`)
  }


  /**
   *  Get single video data
   */
  getVideo(vidKey) {
    return this.db.object(`/social/videos/${vidKey}`);
  }


  /**
   *  Add a user video
   */
  addUserVideo(video, userId) {

    // Switch the format for a video's id (for Firebase purposes)
    let id = video.$key;
    delete video.$key;
    video['attached_members'] = {};

    // Check if video exists, otherwise just create a new one
    this.dbVideosListRef.child(id).once('value').then((snapshot) => {
        if(snapshot.val() === null) {

          // Get the most up to date list of videos and add this to it
          this.dbUsersListRef.child(userId).once('value').then((snapshot) => {
            if(snapshot.val() !== null) {
              let videos = snapshot.val().videos || {};
              videos[id] = true;
              this.db.object(`/social/users/${userId}/videos`).update(videos);
            }
          });

          // Add the video
          video.attached_members[userId] = true;
          this.db.object(`/social/videos/${id}`).set(video);
        } else {

          // Get the most up to date list of videos and add this to it
          this.dbUsersListRef.child(userId).once('value').then((snapshot) => {
            if(snapshot.val() !== null) {

              let videos = snapshot.val().videos || {};
              videos[id] = true;
              this.db.object(`/social/users/${userId}/videos`).update(videos);
            }
          });
          video.attached_members[userId] = true;
          this.db.object(`/social/videos/${id}`).update(video);
        }

        // update the user's last_active
        this.updateUserLastActive();
      });
  }


  /**
   *  Remove a user's association with a video
   */
  removeUserVideos(videosToDelete, userId) {

    // Get the most up to date list of videos and add this to it
    this.dbUsersListRef.child(userId).once('value').then((snapshot) => {
      if(snapshot.val() !== null) {
        let videosFromServer = snapshot.val().videos || {};

        videosToDelete.forEach(result => {

          let id;
          if(result.video_id) {
            id = result.video_id;
          } else {
            id = result.$key;
          }
          delete videosFromServer[id];
        });

        this.db.object(`/social/users/${userId}/videos`).set(videosFromServer);
      }
    });

    // Remove the reference of the attached member on the video itself
    videosToDelete.forEach(result => {

      let id;
      if(result.video_id) {
        id = result.video_id;
      } else {
        id = result.$key;
      }

      this.dbVideosListRef.child(id).once('value').then((snapshot) => {

        if(snapshot.val() !== null) {

          let attached_members = snapshot.val().attached_members;
          delete attached_members[userId];

          this.db.object(`/social/videos/${id}/attached_members`).set(attached_members);
        }
      });
    });

  }


   /**
    *  Update the last time the user was active
    *    - e.g. Submitting a post of some sort
    */
   updateUserLastActive() {
     // this.storage.get('user').then(user => {

     //   // update the user's last_active
     //  let lastActive = {
     //    last_active: new Date().toISOString()
     //  }

     //  this.db.object(`/social/users/${user.id}`).update(lastActive);
     // })
  }


  /**
   *  Get user videos
   */
  getUserVideos(userId) {
    return this.db.list(`/social/users/${userId}/videos`).switchMap((videos:any) => {
      let videoKeys = [];
      videos.forEach(video => {
        videoKeys.push(video.$key);
      })

      return Observable.combineLatest(
        videoKeys.map(videoKey => this.db.object(`/social/videos/${videoKey}`))
      );
    });
  }


  /**
   *  Upload a file
   */
  uploadProfilePhoto(file, type) {
    return firebase.auth().onAuthStateChanged((user) => {
      let id = user.uid;

      var metadata = {
        contentType: 'image/jpeg',
      };
      let userProfileRef;
      if(type === 'profile') {
        userProfileRef = this.fbStorage.ref(`/users/${id}/profile_photo/profile_photo.jpg`);
      } else {
        userProfileRef = this.fbStorage.ref(`/users/${id}/cover_photo/cover_photo.jpg`);
      }

      return userProfileRef.putString(file, 'base64', metadata);
    })
  }

}
